// extracted by mini-css-extract-plugin
export var sliderRange = "_ng-2";
export var sliderRoot = "_ng-0";
export var sliderThumb = "_ng-3";
export var sliderTrack = "_ng-1";